import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lux_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve an image url: full http as-is (downsize Unsplash), backend /api/files via BACKEND_URL, else frontend public asset
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) {
    if (url.includes("images.unsplash.com") && !/[?&]w=/.test(url)) {
      const sep = url.includes("?") ? "&" : "?";
      return `${url}${sep}w=700&auto=format`;
    }
    return url;
  }
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
